import { render, staticRenderFns } from "./SelectCounterpartyModal.vue?vue&type=template&id=05b58bfe&scoped=true&"
import script from "./SelectCounterpartyModal.vue?vue&type=script&lang=ts&"
export * from "./SelectCounterpartyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b58bfe",
  null
  
)

export default component.exports